<template>
    <div
        v-if="categoryId"
        :style="componentStyles"
        class="o-filters-panel"
    >
        <div class="filters-panel-wrapper">
            <button
                v-if="subCategoryId"
                type="button"
                class="filters-panel-button filters-panel-button-selected"
                @click="resetFilter"
            >
                {{ subCategoryName }}
            </button>
            <span class="filters-panel-label">
                {{ 'ui.items.category' | translate }}
            </span>
        </div>
        <div class="filters-panel-wrapper">
            <button
                type="button"
                :class="['filters-panel-button', 'filters-panel-button-all', { 'filters-panel-button-active': selectedCategoryId === null}]"
                @click="showAllCategories"
            >
                {{ 'All' | translate }}
            </button>
            <button
                type="button"
                :class="['filters-panel-button', { 'filters-panel-button-active': selectedCategoryId === index}]"
                v-for="(category, index) in categories"
                :key="category.id"
                @click="setActiveCategory(category, index)"
            >
                {{ t(category, 'name') }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { ROOT_CATEGORY } from "@/components/organisms/o-filters-panel/constants";

export default {
    name: "OFiltersPanel",
    data() {
        return {
            selectedCategoryId: null,
            subCategoryId: null
        }
    },
    props: {
        view: {
            type: String,
            default: ''
        },
        categoryId: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getListItem',
            'getMapConfigProp',
            'getChildCategories',
            'getTenantCategoriesRoot',
            'getServiceCategoriesRoot',
            'getTenantRootCategoryChildren',
        ]),
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OTilesGridWithScroll.params.OFiltersPanel.styles`) || null;
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OFiltersPanel.styles') || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        categories() {
            let categories = [];

            if (this.categoryId === ROOT_CATEGORY) {
                categories = [...this.getTenantRootCategoryChildren];
                this.getServiceCategoriesRoot && categories.push(this.getServiceCategoriesRoot);
                return categories;
            }

            const childCategories = this.getChildCategories(this.categoryId) || null;
            const listItemId = this.getListItem(this.categoryId).parent_id || null;

            if (childCategories.length) {
                categories = childCategories;
            } else if (listItemId){
                categories = this.getChildCategories(listItemId)
            } else {
                categories = this.getChildCategories(this.t(this.getTenantCategoriesRoot, 'id')).slice(0, 3)
            }

            return categories.filter(cat => this.t(cat, 'name'));
        },
        subCategoryName() {
            return this.t(this.getListItem(this.subCategoryId), 'name') || '';
        }
    },
    methods: {
        setActiveCategory(category, index) {
            const childCategories = Boolean(this.getChildCategories(category.id).length) || null;

            if (childCategories) {
                this.subCategoryId = category.id
                this.selectedCategoryId = null
            } else {
                this.selectedCategoryId = index;
            }

            this.$emit('onCategoryChange', category.id);
        },
        resetFilter() {
            const id = this.$route.params.categoryId
                ? Number(this.$route.params.categoryId)
                : this.t(this.getTenantCategoriesRoot, 'id');
          
            this.$emit('onCategoryChange', id);
            this.subCategoryId = null;
            this.selectedCategoryId = null;
        },
        showAllCategories() {
            if (this.selectedCategoryId !== null) {
                this.selectedCategoryId = null;
                this.$emit('onCategoryChange', this.getListItem(this.categoryId).parent_id);
            }
        },
    },
    activated() {
        this.selectedCategoryId = null;
        this.subCategoryId = null;
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
